import { type Registry as Services } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export async function ensureTaskPropertyLoaded(
  task: ModelRegistry['task'],
  store: Services['store'],
  propertyRepository: Services['repositories/property'],
): Promise<void> {
  const propertyId = task.belongsTo('property').id();

  if (!propertyId) {
    return;
  }

  const property = store.peekRecord('property', propertyId);

  if (property?.hasAccommodationInfo && property.belongsTo('address').value()) {
    return;
  }

  await propertyRepository.findRecord(propertyId, { reload: true });
}
